//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';
import { isTruthy } from '@utils/filterPredicates';

export const getUia = (state: ICuralateStore) => state.uiaModal;

export const getIsRightsRequestsViaDmEnabled = createHasFeatureSelector(
  FeatureNames.RightsRequestsViaDm,
);

export const getIsManualRightsConfigurationEnabled = createHasFeatureSelector(
  FeatureNames.RightsManagementPage,
);

export const getIsGenerativeRightsRequestEnabled = createHasFeatureSelector(
  FeatureNames.GenerativeRightsRequest,
);

export const getIsNonAtMentionedRightsRequestsDisplayApiEnabled =
  createHasFeatureSelector(FeatureNames.NonAtMentionedRightsRequestsDisplayApi);

// TODO: PD-269777 - Remove once UIA React port is complete
export const getIsRenderedWithinAnotherWorkflow = createSelector(
  getUia,
  (uiaModal) => {
    return isTruthy(uiaModal.workflow.currentWorkflow);
  },
);

export const getIsBazaarvoiceNetworkSyndicationFrontendEnabled =
  createHasFeatureSelector(FeatureNames.BazaarvoiceNetworkSyndicationFrontend);

export const getIsBazaarvoiceNetworkSyndicationOnlyFullClientEnabled =
  createHasFeatureSelector(
    FeatureNames.BazaarvoiceNetworkSyndicationOnlyFullClient,
  );

// When enabled, rights requests will be checked for the presence of a T&C link
export const getIsRightsRequestTermsAndConditionsEnabled =
  createHasFeatureSelector(FeatureNames.RightsRequestsTermsAndConditions);
